import {Action, useAppContext} from "../../context/Context";
import {BorderStyle, SourceDisplayer} from "./SourceDisplayer";
import { RagOutput } from "../../types/chat";
import {Dispatch, useEffect, useState} from "react";
import { useDeviceType } from "../../hooks/useDeviceType";
import {LoadingAnimationContainer} from "../../utils/loading_animation";
import MarkDownFormater from "./MarkDownFormater";
import {setBottomBarError, setBottomBarSucces} from "../../utils/Functions";
import api from "../../utils/api";


export function openLink(link: string, dispatch: Dispatch<Action>){
    window.open(link, '_blank');
    setBottomBarSucces(dispatch, "Le document a été ouvert, vous devrez peut-être autoriser les fenêtres popup afin de le voir");
}


export async function openDisplayLink(source_id: number, uuid: string, dispatch: Dispatch<Action>){
    openLink(await getDisplayLink(source_id, uuid, dispatch), dispatch);
}


export async function getDisplayLink(source_id: number, uuid: string, dispatch: Dispatch<Action>): Promise<string> {
    try {
        const response = await api.get(`/document/display/${source_id}/${uuid}`);
        return response.data.presigned_url;
    } catch (error) {
        console.error("Failed to download document", error);
        setBottomBarError(dispatch, error);
    }
}


export interface RagContentDisplayProps {
    rag: RagOutput;
    forceDisplayContent?: boolean;
    showPercentages?: boolean;
    companyUUID: string;
}

export default function RagContentDisplay({rag, forceDisplayContent=false, showPercentages=false, companyUUID}: RagContentDisplayProps) {
    const { chunk, source_id, page} = rag;
    const [, dispatch] = useAppContext();
    const [pdfToShow, setpdfToShow] = useState(null)
    const deviceType = useDeviceType();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const waitm = await getDisplayLink(source_id, companyUUID, dispatch);
                setpdfToShow(waitm);
            } catch (error) {
                console.error("Error fetching link:", error);
            }
        };
        fetchData();
    }, [source_id])

    return (

        <div>
            <div>
                <SourceDisplayer
                    rag={rag}
                    clickAction={() => {
                        if (pdfToShow) {
                            openLink(pdfToShow, dispatch);
                        } else {
                            openDisplayLink(source_id, companyUUID, dispatch);
                        }
                    }}
                    percentages={showPercentages}
                    className="p-4"
                    showEye={false}
                    borderStyle={deviceType === "smartphone" && !forceDisplayContent ? BorderStyle.NONE : BorderStyle.BOTTOM}
                />
            </div>
            <div className={`text-sm pt-5 p-4 ${forceDisplayContent ? "" : "max-md:hidden"}`}>
                {showPercentages ? (
                    <MarkDownFormater>
                        {rag.chunk}
                    </MarkDownFormater>
                ) : (
                    pdfToShow ? <iframe src={`${pdfToShow}#page=${page}`} className="fadeIn w-full rounded-lg h-[550px]"/> : <LoadingAnimationContainer/>
                )}
            </div>
        </div>
    );
}
